var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnaroundLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.3327 16.0404C17.067 16.0404 16.041 15.0144 16.041 13.7487C16.041 12.483 17.067 11.457 18.3327 11.457L36.666 11.457C41.7286 11.457 45.8327 15.5611 45.8327 20.6237C45.8327 25.6863 41.7286 29.7904 36.666 29.7904H18.3327C15.8014 29.7904 13.7493 31.8424 13.7493 34.3737C13.7493 36.905 15.8014 38.957 18.3327 38.957H38.9577C40.2233 38.957 41.2494 39.983 41.2494 41.2487C41.2494 42.5144 40.2233 43.5404 38.9577 43.5404H18.3327C13.2701 43.5404 9.16602 39.4363 9.16602 34.3737C9.16602 29.3111 13.2701 25.207 18.3327 25.207H36.666C39.1973 25.207 41.2494 23.155 41.2494 20.6237C41.2494 18.0924 39.1973 16.0404 36.666 16.0404H18.3327Z",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2448 19.0032C23.1398 19.8982 23.1398 21.3492 22.2448 22.2442C21.3499 23.1391 19.8988 23.1391 19.0039 22.2442L12.1289 15.3692C11.2339 14.4742 11.2339 13.0232 12.1289 12.1282L19.0039 5.25324C19.8988 4.35829 21.3499 4.35829 22.2448 5.25324C23.1398 6.1482 23.1398 7.5992 22.2448 8.49415L16.9903 13.7487L22.2448 19.0032Z",
    fill: "#B0B7C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7552 46.5032C31.8602 47.3982 31.8602 48.8492 32.7552 49.7442C33.6501 50.6391 35.1012 50.6391 35.9961 49.7442L42.8711 42.8692C43.7661 41.9742 43.7661 40.5232 42.8711 39.6282L35.9961 32.7532C35.1012 31.8583 33.6501 31.8583 32.7552 32.7532C31.8602 33.6482 31.8602 35.0992 32.7552 35.9942L38.0097 41.2487L32.7552 46.5032Z",
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnaroundLarge);
export default __webpack_public_path__ + "static/media/turnaround-large.2c882dc872f8b56d296d8d5fb513ead8.svg";
export { ForwardRef as ReactComponent };